import PropTypes from "prop-types"
import { map } from "lodash"
import { Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import BetaDetailsRow from "./BetaDetailsRow"

function BetaDetails({ details, selectedDate }) {
  return (
    <div className="details">
      <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="75%" />
            <TableCell align="right">Beta</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(details, (value) => <BetaDetailsRow key={value.id} value={value} />)}
        </TableBody>
      </Table>
    </div>
  )
}

BetaDetails.propTypes = {
  details: PropTypes.array.isRequired,
  selectedDate: DATE,
}

export default BetaDetails
